export default __webpack_public_path__ + "25151a2ee1c97824904de6cb1c4d840a.png";